module.exports = __webpack_public_path__ + "img/Manu_F_.aa68690f.jpg";